import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    const formType = document.querySelector(".new_user").dataset.formType;
    const userType = $("#user-type option:selected").text();

    const merchantProfiles = $("#merchant-profiles");
    const submerchantProfiles = $("#submerchant-profiles");
    const superadminProfiles = $("#superadmin-profiles");
    const customerProfiles = $("#customer-profiles");
    const submerchantField = $("#submerchant-super-ad");
    const merchantField = $("#merchant-super-ad");
    const profileField = $("#profile-field");

    submerchantField.hide();
    merchantField.hide();
    merchantProfiles.hide();
    submerchantProfiles.hide();
    superadminProfiles.hide();
    customerProfiles.hide();

    if (formType == "edit") {
      if (userType == "Merchant") {
        merchantField.show();
        submerchantField.hide();
        merchantProfiles.appendTo(profileField);
        merchantProfiles.show();
      } else if (userType == "Submerchant") {
        submerchantField.show();
        submerchantProfiles.appendTo(profileField);
        submerchantProfiles.show();
      } else if (userType == "Super Admin") {
        superadminProfiles.appendTo(profileField);
        superadminProfiles.show();
      } else if (userType == "Customer") {
        customerProfiles.appendTo(profileField);
        customerProfiles.show();
      }
    }
  }

  hideFields() {
    const userType = $("#user-type option:selected").text();

    const merchantProfiles = $("#merchant-profiles");
    const submerchantProfiles = $("#submerchant-profiles");
    const superadminProfiles = $("#superadmin-profiles");
    const customerProfiles = $("#customer-profiles");
    const submerchantField = $("#submerchant-super-ad");
    const merchantField = $("#merchant-super-ad");

    const profileField = $("#profile-field");

    submerchantField.hide();
    merchantField.hide();
    merchantProfiles.hide();
    submerchantProfiles.hide();
    superadminProfiles.hide();
    customerProfiles.hide();

    if (userType == "Merchant") {
      merchantField.show();
      submerchantField.hide();
      merchantProfiles.appendTo(profileField);
      merchantProfiles.show();
    } else if (userType == "Submerchant") {
      submerchantField.show();
      submerchantProfiles.appendTo(profileField);
      submerchantProfiles.show();
    } else if (userType == "Super Admin") {
      superadminProfiles.appendTo(profileField);
      superadminProfiles.show();
    } else if (userType == "Customer") {
      customerProfiles.appendTo(profileField);
      customerProfiles.show();
    }
  }
}
